module.exports = __webpack_public_path__ + "img/map8.9831f114.png";